import { render, staticRenderFns } from "./NormalCourses.vue?vue&type=template&id=007e1921&"
import script from "./NormalCourses.vue?vue&type=script&lang=js&"
export * from "./NormalCourses.vue?vue&type=script&lang=js&"
import style0 from "./NormalCourses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports